var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styledComponent from "styled-components";
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { useTranslation } from 'react-i18next';
import { HIDDEN, INPUT_LABEL, INPUT_GROUP, INPUT, IS_INVALID, SELECT, INPUT_DESCRIPTION } from "../../../classConstants";
import { ErrorTypes, ErrorText } from "../";
import { Flex } from '../../Flex';
import parse from 'html-react-parser';
import { getClassName } from '../../../helpers';
import { useConfig, usePresentationComponent } from '../../../AppContext';
import { SvgIcon } from '../../../icons';
import get from 'lodash/get';
import keys from "lodash/keys";
import assign from "lodash/assign";
var getResetProps = function (reset, state, name) {
    switch (typeof reset) {
        case "function": return reset(state, name);
        case "object": return reset;
        default: return {};
    }
};
var getOptionsObject = function (option) {
    var localOption = typeof option === 'object' ? __assign(__assign({}, option), { label: "" + option.label, value: "" + option.value }) : {
        label: '',
        value: '',
    };
    if (typeof option !== 'object') {
        localOption.label = "" + option;
        localOption.value = "" + option;
    }
    ;
    return localOption;
};
var SelectComponent = function (props) {
    var Component = usePresentationComponent("select");
    var isAdmin = useConfig("is_admin")[0];
    var t = useTranslation().t;
    var _a = props.children, children = _a === void 0 ? null : _a, value = props.value, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.required, required = _c === void 0 ? false : _c, _d = props.reverse, reverse = _d === void 0 ? false : _d, label = props.label, meta = props.meta, name = props.name, _e = props.input, _f = _e === void 0 ? {} : _e, onChange = _f.onChange, input = __rest(_f, ["onChange"]), _g = props.disabled, disabled = _g === void 0 ? false : _g, hideReason = props.hideReason, _h = props.isInline, isInline = _h === void 0 ? false : _h, _j = props.isHidden, isHidden = _j === void 0 ? false : _j, _k = props.reset, reset = _k === void 0 ? undefined : _k;
    var classList = [INPUT_GROUP];
    var wrapClassList = [];
    var showDescription = !!(label && children);
    var errorMessage = props.error_message;
    var isInvalid = !!errorMessage || ((meta === null || meta === void 0 ? void 0 : meta.touched) && (meta === null || meta === void 0 ? void 0 : meta.error));
    var childrenComponent = typeof children === "string" ? parse(children) : children;
    // const preselectAndHide = !isHidden && required && (props.options.length === 1 && !(props.options[0] as ISelectOption).children?.length);
    classList.push(name.replace(/\[(.+)\]/g, "-\$1") + "-input");
    if (isInvalid)
        classList.push(IS_INVALID);
    if (className)
        classList.push(className);
    if (isHidden) {
        hideReason ? wrapClassList.push(HIDDEN) : classList.push(HIDDEN);
    }
    var getError = function () {
        if (!isInvalid)
            return null;
        var Required = meta && ErrorTypes[meta.error];
        return Required ? React.createElement(Required, { className: className, label: label }) : React.createElement(ErrorText, { className: className, label: label, error: errorMessage });
    };
    var renderDisplayText = function () {
        if (!label && isInvalid)
            return null;
        var labelComponent = typeof label === "string" ? parse(label) : label;
        var className = getClassName(INPUT_LABEL, "ws-select-label");
        return React.createElement(React.Fragment, null, getError()
            || React.createElement("span", { className: className },
                labelComponent || childrenComponent,
                required && React.createElement("span", null, "*")));
    };
    var renderOptions = function (optns) {
        if (optns === void 0) { optns = []; }
        return optns.map(function (option, i) {
            var _a = getOptionsObject(option), label = _a.label, children = _a.children, optionAttributes = __rest(_a, ["label", "children"]);
            if (children) {
                return React.createElement("optgroup", { label: label, key: optionAttributes.value }, renderOptions(children));
            }
            ;
            return React.createElement("option", __assign({ key: "option-" + i }, optionAttributes, { dangerouslySetInnerHTML: { __html: label } }));
        });
    };
    var ogOnChange = onChange || props.onChange;
    var handleOnChange = React.useCallback(function (e) {
        if (Component) {
            ogOnChange(e);
            return;
        }
        (ogOnChange === null || ogOnChange === void 0 ? void 0 : ogOnChange(e.target.value, e));
    }, [Component, ogOnChange]);
    var selectChildren = renderOptions(props.options);
    if (!required && props.hideOnNoOptions !== false && selectChildren.length === 0) {
        return null;
    }
    var selectProps = {
        disabled: disabled,
        name: name,
        onChange: handleOnChange,
        value: "" + (value || (input === null || input === void 0 ? void 0 : input.value) || "")
    };
    var renderAlternateView = function () {
        // @ts-ignore
        assign(selectProps, {
            required: required, label: label,
            options: props.options.map(getOptionsObject),
            allowBlank: get(props, "allowBlank"),
            trans: t,
            error: getError()
        });
        return (React.createElement(React.Fragment, null, isHidden ? renderInput() : React.createElement(Component, __assign({}, selectProps))));
    };
    var renderInput = function () { return (React.createElement("input", __assign({ type: "hidden" }, (input || {}), { onChange: onChange || props.onChange, value: value || (input === null || input === void 0 ? void 0 : input.value) }))); };
    var renderDescription = function () { return (isHidden || !showDescription ? null : React.createElement(Flex, { className: INPUT_DESCRIPTION, isInline: false },
        " ",
        childrenComponent,
        " ")); };
    var renderHideReason = function () { return (!isHidden || !hideReason ? null : React.createElement(Flex, { className: getClassName(INPUT_DESCRIPTION, "ws-input-hidden-reason", props.hideReasonClassNamee), isInline: false },
        " ",
        hideReason,
        " ")); };
    var Wrap = function (props) { return (React.createElement(Flex, __assign({}, props, { isInline: !isAdmin && isInline, reverse: reverse, forwardedAs: "label" }))); };
    var renderDefaultOption = function () {
        if (props.showDefaultOption === false)
            return null;
        return React.createElement("option", { key: "default_value", value: "" }, props.placeholder || t('common.select', { label: label }));
    };
    var renderSelect = function () {
        var type = isInvalid ? "error" : "arrow";
        var iconProps = assign({ type: type }, type === "arrow" && { width: ".6em", className: "ws-select-caret" });
        return React.createElement(React.Fragment, null,
            !Component && renderDisplayText(),
            Component ?
                renderAlternateView()
                : (React.createElement(FieldWrap, null,
                    React.createElement("select", __assign({ key: "select", className: SELECT + " " + INPUT }, selectProps),
                        React.createElement(React.Fragment, { key: "defaultOption" }, renderDefaultOption()),
                        React.createElement(React.Fragment, { key: "options" }, selectChildren)),
                    React.createElement(SelectIcon, __assign({ key: "icon" }, iconProps)))));
    };
    return (React.createElement("div", { className: classList.join(' ') },
        React.createElement(Wrap, { className: getClassName(wrapClassList) }, isHidden ? renderInput() : renderSelect()),
        renderDescription(),
        renderHideReason()));
};
var FieldWrap = styledComponent.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    .", " { width: 100%; }\n"], ["\n    position: relative;\n    .", " { width: 100%; }\n"])), INPUT);
export var Select = styledComponent(SelectComponent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    select.", " {\n        appearance: none;\n        background-image: none;\n        padding-right: var(--ws-select-icon-padding, 2em);\n    }\n    .", " {\n        width: 100%;\n        > *:first-child { margin-top: 0; }\n        > *:last-child { margin-bottom: 0; }\n    }\n\n    &.extra-prices {\n        label {\n            flex-wrap: nowrap;\n        }    \n        ", " {\n            margin-right: 1em;\n            margin-right: var(--ws-input-margin);\n            min-width: 50px;\n        }\n    }\n"], ["\n    select.", " {\n        appearance: none;\n        background-image: none;\n        padding-right: var(--ws-select-icon-padding, 2em);\n    }\n    .", " {\n        width: 100%;\n        > *:first-child { margin-top: 0; }\n        > *:last-child { margin-bottom: 0; }\n    }\n\n    &.extra-prices {\n        label {\n            flex-wrap: nowrap;\n        }    \n        ", " {\n            margin-right: 1em;\n            margin-right: var(--ws-input-margin);\n            min-width: 50px;\n        }\n    }\n"])), INPUT, INPUT_DESCRIPTION, FieldWrap);
var SelectIcon = styledComponent(SvgIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    pointer-events: none;\n    position: absolute;\n    right: .6em;\n    height: calc(100% - .6em);\n    top: 50%;\n    transform: translateY(-50%);\n    ", "\n"], ["\n    pointer-events: none;\n    position: absolute;\n    right: .6em;\n    height: calc(100% - .6em);\n    top: 50%;\n    transform: translateY(-50%);\n    ", "\n"])), function (_a) {
    var width = _a.width;
    return "width : " + (width || "1em") + ";";
});
export var ReactiveSelect = function (props) {
    var className = props.className, name = props.name, children = props.children, hideReason = props.hideReason;
    var formOptions = useFormApi();
    var alternateView = !!usePresentationComponent("select");
    var _a = useFieldApi(props), getOptions = _a.getOptions, getDynamicValue = _a.getDynamicValue, input = _a.input, optionsProp = _a.options, fieldProps = __rest(_a, ["getOptions", "getDynamicValue", "input", "options"]);
    var state = formOptions.getState().values;
    var reset = (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.reset) || null;
    var options = getOptions ? getOptions(state) : optionsProp;
    if (!fieldProps.required && (options === null || options === void 0 ? void 0 : options.length) <= 0)
        return null;
    if (alternateView) {
        input.onChange = function (value) {
            formOptions.change(name, value || undefined);
        };
    }
    if (getDynamicValue) {
        var onChange_1 = input.onChange;
        input.onChange = (function (x, e) {
            var obj = getDynamicValue({ value: x }, state);
            var fields = [].concat(obj);
            formOptions.change("skip", true);
            fields.forEach(function (_a) {
                var key = _a.key, value = _a.value;
                formOptions.change("skip", true);
                if (key) {
                    formOptions.change(key, value);
                }
                ;
            });
            if (!fields.some(function (field) { return get(field, "key") === (input === null || input === void 0 ? void 0 : input.name); })) {
                onChange_1(x);
            }
            formOptions.change("skip", undefined);
        });
    }
    if (reset) {
        var onChange_2 = input.onChange;
        input.onChange = (function (x, event) {
            var resetProps = getResetProps(reset, state, name);
            formOptions.batch(function () {
                formOptions.change("skip", true);
                keys(resetProps).forEach(function (key) { return formOptions.change(key, resetProps[key]); });
                onChange_2(event || x);
                formOptions.change("skip", undefined);
            });
        });
    }
    return React.createElement(Select, __assign({}, fieldProps, { hideReason: hideReason, input: input, options: options, placeholder: fieldProps.placeholder, className: className, children: children, name: name }));
};
var templateObject_1, templateObject_2, templateObject_3;
